import React, { useState } from "react";
import './Subscription.scss';

export const sellerPlans = [
  {
    id: 'freeby',
    name: 'Freeby',
    description: '',
    price: 0,
    period: 'month',
    features: [
      {
        section: 'Marketplace sales fee',
        items: [
          { text: 'Your existing customers', value: '0%' },
          { text: 'Customers through Tyrrst', value: '20%' },
        ],
      },
      {
        section: 'Payment',
        items: [
          { text: 'Accelerated payment (5 days)', value: '2%' },
          { text: '30 day payment', value: '0%' },
        ],
      },
    ],
    buttonText: 'Sign me up',
  },
  {
    id: 'premium',
    name: 'Premium',
    description: '',
    price: 150,
    period: 'month',
    features: [
      {
        section: 'Marketplace sales fee',
        items: [
          { text: 'Your existing customers', value: '0%' },
          { text: 'Customers through Tyrrst', value: '15%' },
        ],
      },
      {
        section: 'Payment',
        items: [
          { text: 'Accelerated payment (5 days)', value: '1.5%' },
          { text: '30 day payment', value: '0%' },
        ],
      },
      {
        section: 'Tyrrst storage',
        items: [
          { text: '2 pallets (1 SKU each)', value: '✔', isCheckmark: true },
          { text: 'Add pallet (1 SKU each)', value: '€11/month' },
          { text: 'Inventory system', value: '✔', isCheckmark: true },
        ],
      },
      {
        section: 'Tyrrst fulfilment',
        items: [
          { text: 'Excise solution (Europe)', value: '✔', isCheckmark: true },
          { text: 'Pick, pack & custom clearance', value: '9.5%' },
        ],
      },
    ],
    buttonText: 'Sign me up',
    isSelected: true,
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    description: '',
    price: 275,
    period: 'month',
    features: [
      {
        section: 'Marketplace sales fee',
        items: [
          { text: 'Accelerated payment (5 days)', value: '0%' },
          { text: 'Customers through Tyrrst', value: '12%' },
        ],
      },
      {
        section: 'Payment',
        items: [
          { text: 'Accelerated payment (5 days)', value: '1%' },
          { text: '30 day payment', value: '0%' },
        ],
      },
      {
        section: 'Tyrrst storage',
        items: [
          { text: '4 pallets (1 SKU each)', value: '✔', isCheckmark: true },
          { text: 'Add pallet (1 SKU each)', value: '€10.10/month' },
          { text: 'Inventory system', value: '✔', isCheckmark: true },
        ],
      },
      {
        section: 'Tyrrst fulfilment',
        items: [
          { text: 'Excise solution (Europe)', value: '✔', isCheckmark: true },
          { text: 'Pick, pack & custom clearance', value: '8.5%' },
        ],
      },
    ],
    buttonText: 'Sign me up',
  },
];

export const buyerPlan = {
  name: 'Freeby',
  description: '',
  price: 0,
  period: 'month',
  features: [
    {
      section: 'Marketplace',
      items: [
        { text: 'Search products across many brands' },
        { text: 'Buy multiple brands on a single invoice' },
        { text: 'Free shipment over Euro 300' },
        { text: 'Directly message brands' },
        { text: 'Tender for special needs' },
        { text: 'Collect Tyrrst Membership points' },
        { text: 'Save 5%, 8%, 10% or more' },
      ],
    },
    {
      section: 'Payment',
      items: [
        { text: 'Financing up to 90 days' },
      ],
    },
  ],
  buttonText: 'Sign me up',
};

const SUBSCRIPTION_DESCRIPTIONS = {
  seller: '',
  buyer: '',
};

const HEADLINE = 'Choose your subscription';
const SUBHEAD = 'We offer three subscription plans to meet your business needs. Select the plan that best suits your requirements.';

const Subscription = ({ selected = 'seller', onSignUpClick }) => {
  const [selectedPlan, setSelectedPlan] = useState('premium');
  
  if (selected === 'buyer') {
    return (
      <div className="SubscriptionPage__container">
        <h1 className="SubscriptionPage__title">{HEADLINE}</h1>
        <p className="SubscriptionPage__desc">{SUBHEAD}</p>
        <div className="SubscriptionCard">
          <div className="SubscriptionCard__header">
            <span className="SubscriptionCard__badge">{buyerPlan.name}</span>
            <div className="SubscriptionCard__price">
              <span className="SubscriptionCard__price-main">€{buyerPlan.price}.00</span>
              <span className="SubscriptionCard__price-period">/{buyerPlan.period}</span>
            </div>
          </div>
          <div className="SubscriptionCard__features">
            {buyerPlan.features.map((feature, idx) => (
              <div className="SubscriptionCard__section" key={idx}>
                <div className="SubscriptionCard__section-title">{feature.section}</div>
                <ul>
                  {feature.items.map((item, i) => (
                    <li key={i}>
                      {item.text} {item.value && <span className="SubscriptionCard__feature-value">{item.value}</span>}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <button className="SubscriptionCard__button SubscriptionCard__button--selected" onClick={onSignUpClick} type="button">
            {buyerPlan.buttonText}
          </button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="SubscriptionPage__container">
      <h1 className="SubscriptionPage__title">{HEADLINE}</h1>
      <p className="SubscriptionPage__desc">{SUBHEAD}</p>
      <div className="SubscriptionPage__cards">
        {sellerPlans.map((plan) => (
          <div 
            key={plan.id} 
            className={`SubscriptionCard ${selectedPlan === plan.id ? 'SubscriptionCard--selected' : ''}`}
          >
            <div className="SubscriptionCard__header">
              <span className="SubscriptionCard__badge">{plan.name}</span>
              <div className="SubscriptionCard__price">
                <span className="SubscriptionCard__price-main">€{plan.price}.00</span>
                <span className="SubscriptionCard__price-period">/{plan.period}</span>
              </div>
            </div>
            <div className="SubscriptionCard__features">
              {plan.features.map((feature, idx) => (
                <div className="SubscriptionCard__section" key={idx}>
                  <div className="SubscriptionCard__section-title">{feature.section}</div>
                  <ul>
                    {feature.items.map((item, i) => (
                      <li key={i}>
                        {item.text} 
                        {item.value && (
                          item.isCheckmark ? 
                            <span className="SubscriptionCard__feature-checkmark">{item.value}</span> : 
                            <span className="SubscriptionCard__feature-value">{item.value}</span>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <button 
              className={`SubscriptionCard__button ${selectedPlan === plan.id ? 'SubscriptionCard__button--selected' : ''}`} 
              onClick={() => {
                setSelectedPlan(plan.id);
                if (onSignUpClick) onSignUpClick(plan.id);
              }} 
              type="button"
            >
              {selectedPlan === plan.id ? 'Selected' : plan.buttonText}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Subscription;
